import { motion, useReducedMotion } from "framer-motion";
import { AlertCircle, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { COCKPIT } from "../../constants/testIds";
import { fadeUp } from "../../lib/motion";

// UX-01 §1 "Needs attention panel" + UX-RM §1A: server-composed via `GET /reports/attention`
// (dues-climbing + reconciliation-mismatch + at-risk, each with a deterministic one-sentence
// reason) — the "AI-without-AI" differentiator (honest, not a black-box). This component just
// renders the feed; the composition itself now lives in `readmodels_engine.attention_list`.
export function NeedsAttentionPanel({ items }) {
  const reducedMotion = useReducedMotion();

  if (!items || items.length === 0) {
    return (
      <div className="solid-surface rounded-[14px] p-6 text-sm" style={{ color: "var(--scarlet-text-secondary)" }} data-testid={COCKPIT.needsAttentionPanel}>
        Nothing needs your attention right now — nice work.
      </div>
    );
  }

  return (
    <div className="solid-surface rounded-[14px] p-5" data-testid={COCKPIT.needsAttentionPanel}>
      <p className="eyebrow mb-3">Needs attention</p>
      <div className="space-y-1">
        {items.map((row, i) => (
          <motion.div key={i} {...fadeUp(reducedMotion, i * 0.04, 6)}>
            <Link to={row.link} data-testid={COCKPIT.needsAttentionRow(i)} className="flex items-start gap-3 p-2.5 rounded-[10px] hover:bg-black/[0.03] group scarlet-focusable">
              <AlertCircle size={16} className="mt-0.5 shrink-0" style={{ color: "var(--status-expiring-text)" }} />
              <div className="flex-1">
                <p className="text-sm font-medium" style={{ color: "var(--scarlet-text)" }}>{row.member_name || "Reconciliation"}</p>
                <p className="text-xs" style={{ color: "var(--scarlet-text-secondary)" }}>{row.reason}</p>
              </div>
              <ArrowRight size={14} className="mt-1 opacity-0 group-hover:opacity-60 transition-opacity" />
            </Link>
          </motion.div>
        ))}
      </div>
    </div>
  );
}
